import type { Dispatch, SetStateAction } from "react";

import { Trash2 } from "lucide-react";

import { ConfirmationModal } from "@/components/confirmation-modal";

interface DeleteAssetModalProps {
  assetName?: string;
  isDeleting?: boolean;
  isOpen: boolean;
  onDelete: () => void;
  onOpenChange: Dispatch<SetStateAction<boolean>>;
}

export function DeleteAssetModal({
  assetName,
  isDeleting = false,
  isOpen,
  onDelete,
  onOpenChange,
}: DeleteAssetModalProps) {
  const title = "Delete Asset";
  const text = assetName
    ? `Are you sure you want to delete "${assetName}"? This action cannot be undone.`
    : "Are you sure you want to delete this asset? This action cannot be undone.";

  return (
    <ConfirmationModal
      confirmButtonColor="destructive"
      confirmButtonText="Delete"
      icon={<Trash2 className="text-featured-icon-light-fg-error" />}
      isConfirmLoading={isDeleting}
      isOpen={isOpen}
      onConfirm={onDelete}
      onOpenChange={onOpenChange}
      text={text}
      title={title}
    />
  );
}
